import React from 'react'
import { Icon, Text, CardContainer } from '@adc/ui-morpheus'
import { constants } from '@adc/ui-core'
import type { CognitionEvaluationRubric } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface ExternalUserFeedbackSectionProps {
  rubric: CognitionEvaluationRubric
}

const ExternalUserFeedbackSection: React.FC<
  ExternalUserFeedbackSectionProps
> = ({ rubric }) => {
  // eslint-disable-next-line no-nested-ternary
  const rating = rubric.score
    ? 'thumbsUp'
    : rubric.score === false
    ? 'thumbsDown'
    : null

  return (
    <CardContainer
      backgroundColor={constants.ColorNames.White}
      borderRadius='medium'
      padding='small'
      borderStyle='line'
      borderColor={constants.ColorNames.GrayLight}
    >
      <Text size='large' weight='heavy' className={cx('section-title')}>
        User Feedback
      </Text>

      <div className={cx('detail-row')} data-elm-id='external_user_rating'>
        <Text size='small' color='gray'>
          Rating:
        </Text>
        <div>
          {rating ? (
            <>
              <Icon
                data-elm-id='external_user_rating_icon'
                iconStyle='solid'
                name={rating === 'thumbsUp' ? 'thumbs-up' : 'thumbs-down'}
                color={rating === 'thumbsUp' ? 'success' : 'error'}
                size='large'
              />
            </>
          ) : (
            <Text size='small'>Not rated</Text>
          )}
        </div>
      </div>

      <div className={cx('comment-section')}>
        <Text
          size='small'
          color='gray'
          style={{ marginBottom: '8px', display: 'block' }}
        >
          Comment
        </Text>
        <CardContainer
          style={{ marginTop: '8px' }}
          backgroundColor={constants.ColorNames.OffWhite}
          padding='extra-small'
          borderRadius='medium'
        >
          {rubric?.notes || 'No comment provided'}
        </CardContainer>
      </div>
    </CardContainer>
  )
}

export default ExternalUserFeedbackSection
